import React, {useEffect, useState, useRef} from "react";
import {DraggableDialog} from "components"
import socketIOClient from "socket.io-client";
import {useHistory, useParams} from "react-router-dom";
import {
    Box,
    Card,
    CardActions,
    Typography,
    Button,
    Slider,
    CardContent,
    CircularProgress,
    Grid,
    Input,
    Link, Snackbar, Alert, DialogContent, DialogActions
} from "@mui/material";
import {useWeb3React} from "@web3-react/core";
import {
    getTokenInfo,
    tokenMinted,
    mintedTokens,
    updateTokenMetadata,
    uploadTokenMetadata,
    mintAvailable,
    getTokensByOwner
} from "../lib/api/token";
import {toast} from 'react-toastify';
import {MillionContractAddress} from "lib/contracts";
import MillionABI from "lib/abi/MillionABI.json";
import Web3 from 'web3';
import {Edit} from "@mui/icons-material";
import {shortenAddress} from "@usedapp/core";

let scale = 0;
let minscale = 0;
let initialScale = 0;
let prevX = 0;
let prevY = 0;
let prevOffsetX = 0;
let prevOffsetY = 0;
let pannelSize = 0;
let movePoints = 0;
let sliderPos = 0;
const marks = [
    {
        value: 20,
        label: "0",
    },
    {
        value: 100,
        label: "100",
    },

];
const TokenSection = () => {
    const history = useHistory();
    const {active, chainId, account, activate, deactivate, library, connector} =
        useWeb3React();
    const [time, setTime] = useState(new Date().getTime());
    const [imgWidth, setImgWidth] = useState(0);
    const [windowWidth, setWindowWidth] = useState(0);
    const [mapContainerMargin, setMapContainerMargin] = useState(0);
    const [selectedToken, setSelectedToken] = useState({x: 0, y: 0});
    const [selectedTokens, setSelectedTokens] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [tokenInfo, setTokenInfo] =  useState();
    const [message, setMessage] = useState('');
    const [tokenImageAspectRatio, setTokenImageAspectRatio] = useState(1);
    const [mapStatus, setMapStatus] = useState({
        scale: 1,
        offsetX: 0,
        offsetY: 0,
    });
    const [price, setPrice] = useState(0);
    const [balance, setBalance] = useState(0);
    const [contract, setContract] = useState(null);
    const [selectedOwner, setSelectedOwner] = useState('');
    const [state, setState] = useState({
        mintBlockHeight: 1,
        mintBlockWidth: 1,
        description: '',
        tokenUrl: '',
        tokenImageUrl: ''
    });
    const imgContainer = useRef();
    const map = useRef();
    const tokenImage = useRef();
    const canvas = useRef();
    let {address, curTokenId} = useParams();
    const backendUrl = process.env.NODE_ENV == 'development'? 'http://localhost:5000':process.env.REACT_APP_BACKEND_URL;

    /// handling when page url changed
    useEffect(() => {
        console.log(address, curTokenId, "address & tokenId")
        let currentTokenId = curTokenId * 1;
        if (address && !selectedOwner) {
            /// user navigated to owner/:address site by user operation
            setSelectedOwner(address);
            setTokenInfo(null);
            setSelectedToken({x: 0, y: 0})
        } else if (currentTokenId && selectedToken.x == 0 && selectedToken.y == 0) {
            let x = (currentTokenId % 100 ? currentTokenId % 100 : 100);
            let y = (currentTokenId - x) / 100 + 1;
            console.log(x, y, "x_y_")
            setSelectedToken({x: x, y: y});
            setSelectedOwner('');
        }
        if (!address) {
            setSelectedOwner('');
        }
        if (!currentTokenId) {
            setTokenInfo(null);
            setSelectedToken({x: 0, y: 0})
        }
    }, [address, curTokenId])

    /// handling when wallet connected
    useEffect(async () => {
        if (account && chainId == (process.env.REACT_APP_MODE == 'TEST' ? 3 : 1)) {
            if (window.ethereum) {
                window.web3 = new Web3(window.ethereum);
                window.ethereum.enable();
            }
            let millionContract = await new window.web3.eth.Contract(MillionABI, MillionContractAddress);
            setContract(millionContract);
        } else {
            setContract(null);
        }

    }, [account, chainId]);

    /// socket handling
    useEffect(() => {
        const socket = socketIOClient(backendUrl, {transports: ['websocket']});
        socket.on("token-updated", data => {
            const {tokenId, width, height} = data;
            console.log(tokenId, width, height, "token info updated");
            const ctx = canvas.current.getContext('2d');
            for (let i = 0; i < height; i++) {
                for (let j = 0; j < width; j++) {
                    const Id = tokenId + i * 100 + j;
                    drawToken(ctx, {tokenId: Id, resizableImageUrl: `images/resizeImage/${Id}.png`});
                }
            }
        });
        return () => socket.disconnect();
    }, []);

    /// getting wallet balance & token price
    useEffect(async () => {
        if (contract) {
            const tokenPrice = await contract.methods.mintPrice().call() / (10 ** 18);
            setPrice(tokenPrice);
            const walletBalance = await window.web3.eth.getBalance(account) / (10 ** 18);
            setBalance(walletBalance);
        }
    }, [contract])

    const updateWindow = () => {
        setWindowWidth(window.innerWidth);
    };

    /// change token image width/height, scale etc when windows width changed
    useEffect(() => {
        if (windowWidth > 0) {
            if (window.innerWidth >= 1050) {
                setImgWidth(1000);
                pannelSize = 1000;
                minscale = scale = initialScale = 0.2;
                sliderPos = (window.innerWidth - 1000) / 2 - 20;
            } else if (window.innerWidth >= 540) {
                setImgWidth(500);
                pannelSize = 500;
                minscale = scale = initialScale = 0.1;
                sliderPos = (window.innerWidth - 500) / 2 - 20;
            } else {
                let img_width = window.innerWidth - 40;
                setImgWidth(img_width);
                pannelSize = img_width;
                minscale = scale = initialScale = img_width / 5000;
            }
            setMapContainerMargin((windowWidth - pannelSize) / 2);
            setMapStatus({...mapStatus, scale: scale});
            map.current.style.transform = `translate(0,0) scale(${initialScale})`;
        }
    }, [windowWidth]);

    /// event handlers
    useEffect(() => {

        imgContainer.current.addEventListener("wheel", zoom, {passive: false});
        imgContainer.current.addEventListener("mousemove", onImgMouseMove, {
            passive: false,
        });
        imgContainer.current.addEventListener("mouseup", onImgMouseUp, {
            passive: false,
        });
        imgContainer.current.addEventListener("mousedown", onImgMouseDown, {
            passive: false,
        });
        window.addEventListener("resize", updateWindow);
        setWindowWidth(window.innerWidth);
        return () => {
            if (imgContainer.current) {
                imgContainer.current.removeEventListener("wheel", zoom);
                imgContainer.current.removeEventListener("mousemove", onImgMouseMove);
                imgContainer.current.removeEventListener("mouseup", onImgMouseUp);
                imgContainer.current.removeEventListener("mousedown", onImgMouseDown);
            }
        };
    }, []);

    /// canvas manipulating
    useEffect(() => {
        const ctx = canvas.current.getContext('2d');
        mintedTokens((success, list) => {
            if (success)
                list.forEach(info => drawToken(ctx, info));
        })
    }, []);

    /// token selection change handling
    useEffect(() => {
        if (selectedToken.x && selectedToken.y) {
            setProcessing(true);
            let tokenId = (selectedToken.y - 1) * 100 + selectedToken.x
            history.push(`/tokens/${tokenId}`)
            getTokenInfo(tokenId, (success, data) => {
                setProcessing(false);
                if (success) {
                    const tokenImgUrl = data.groupId ? `${backendUrl}/images/groupImage/${data.groupId}.png?t=${new Date().getTime()}` : `${backendUrl}/images/resizeImage/${data.tokenId}.png?t=${new Date().getTime()}`
                    //const tokenImgUrl = data.groupId? `${backendUrl}/images/groupImage/${data.groupId}.png?t=${new Date().getTime()}` : data.imageUrl
                    setState({
                        ...state,
                        description: data.description,
                        tokenUrl: data.url || '',
                        tokenImageUrl: tokenImgUrl
                    })
                    setTokenInfo(data);
                    //TODO
                    if (tokenImage.current)
                        tokenImage.current.style.aspectRatio = data.groupId ? data.group.width / data.group.height : 1;
                    setTokenImageAspectRatio(data.groupId ? data.group.width / data.group.height : 1)
                    return;
                } else {
                    toast.error("Can't get token info! Server Error!")
                }
            })
        } else if (tokenInfo) {
            /// when user closed token view dialog
            setTokenInfo(null);
            history.push(`/`)
        }
    }, [selectedToken])

    useEffect(() => {
        if (selectedOwner) {
            setProcessing(true)
            getTokensByOwner(selectedOwner, (success, data) => {
                setProcessing(false)
                if(success) setSelectedTokens(data);
            });
        }
    }, [selectedOwner])
    const drawToken = (ctx, info) => {
        var img = new Image();
        const tokenId = info.tokenId;
        let X = (tokenId % 100 == 0 ? 100 : tokenId % 100) - 1;
        let Y = (tokenId - X - 1) / 100;
        // console.log(X, Y, `${backendUrl}/${info.resizableImageUrl}`)
        img.src = `${backendUrl}/${info.resizableImageUrl}`;
        img.onload = () => {
            ctx.drawImage(img, X * 50, Y * 50, 50, 50);
        }
    }

    const zoom = (event) => {
        event.preventDefault();
        let newScale = scale;
        newScale += (event.deltaY / 100) * -0.03;
        // Restrict scale
        newScale = Math.min(Math.max(minscale, newScale), 1);
        let offsetY = 0;
        let offsetX = 0;
        if (scale != minscale) {
            offsetX = (prevOffsetX * (newScale - minscale)) / (scale - minscale);
            offsetY = (prevOffsetY * (newScale - minscale)) / (scale - minscale);
            console.log(offsetX, offsetY, "new offset when zooming");
        }
        prevOffsetX = offsetX;
        prevOffsetY = offsetY;
        setMapStatus({offsetX: offsetX, offsetY: offsetY, scale: newScale});
        scale = newScale;
        // Apply scale transform
        map.current.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
        console.log("current scale:", scale);
        return;
    };

    const onImgMouseMove = (event) => {
        event.preventDefault();
        if (event.buttons != 1) return;
        let curX = event.screenX;
        let curY = event.screenY;
        let moveX = curX - prevX;
        let moveY = curY - prevY;
        prevX = curX;
        prevY = curY;
        let offsetX = prevOffsetX + moveX;
        let offsetY = prevOffsetY + moveY;
        movePoints++;
        if (
            offsetX > 0 ||
            offsetX < pannelSize - 5000 * scale ||
            offsetY > 0 ||
            offsetY < pannelSize - 5000 * scale
        )
            return;
        prevOffsetX = offsetX;
        prevOffsetY = offsetY;
        setMapStatus({offsetX: offsetX, offsetY: offsetY, scale: scale});
        map.current.style.cursor = "move";
        map.current.style.transform = `translate(${offsetX.toFixed(
            0
        )}px, ${offsetY.toFixed(0)}px) scale(${scale})`;
        return;
    };

    const onImgMouseDown = (event) => {
        event.preventDefault();
        prevX = event.screenX;
        prevY = event.screenY;
    };

    const onImgMouseUp = (event) => {
        event.preventDefault();
        prevX = 0;
        prevY = 0;
        map.current.style.cursor = "default";
        if (movePoints < 5) {
            let x = Math.ceil(event.offsetX / 50);
            let y = Math.ceil(event.offsetY / 50);
            setSelectedToken({x: x, y: y});
        }
        movePoints = 0;
    };

    const onSliderChange = (event, value) => {
        // value = scale * 100;
        // console.log("change");
        // console.log(value);
        let newScale = value / 100;
        let offsetY = 0;
        let offsetX = 0;
        if (scale != minscale) {
            offsetX = (prevOffsetX * (newScale - minscale)) / (scale - minscale);
            offsetY = (prevOffsetY * (newScale - minscale)) / (scale - minscale);
            console.log(offsetX, offsetY, "new offset when zooming");
        }
        prevOffsetX = offsetX;
        prevOffsetY = offsetY;
        setMapStatus({offsetX: offsetX, offsetY: offsetY, scale: newScale});
        scale = newScale;
        // Apply scale transform
        map.current.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
        console.log("current scale:", scale);
        return;
    };

    const changeHandler = (event) => {
        const {name, value} = event.target;
        if (value.toString().length && value < 1) return;
        setState({...state, [name]: value});
    }

    const mintProcess = async () => {
        setMessage('Minting Token ...');
        if (state.mintBlockHeight == 1 && state.mintBlockWidth == 1) {
            contract.methods.mintToken((selectedToken.y - 1) * 100 + selectedToken.x).send({
                from: account,
                value: price * (10 ** 18)
            })
                .on('receipt', function (receipt) {
                    setMessage('')
                    if (!receipt.status) {
                        setProcessing(false);
                        toast.error(receipt.message || "Error while minting!");
                        return;
                    } else {
                        ///  process with backend
                        toast.success('Successfully token minted! Updating token info ..');
                        setMessage('Updating  token info ...');
                        tokenMinted({
                            tokenId: (selectedToken.y - 1) * 100 + selectedToken.x,
                            width: state.mintBlockWidth,
                            height: state.mintBlockHeight,
                            account: account
                        }, (success, data) => {
                            setMessage('');
                            if (success) toast.success('Successfully token info updated!');
                            else toast.warning(data.message);
                            setSelectedToken({x: 0, y: 0});
                            setState({
                                mintBlockHeight: 1,
                                mintBlockWidth: 1,
                                description: '',
                                tokenUrl: '',
                                tokenImageUrl: ''
                            });
                        })
                    }

                })
                .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                    setMessage('')
                    setProcessing(false);
                    toast.error(error.message)
                });

        } else {
            contract.methods.mintTokenGroup((selectedToken.y - 1) * 100 + selectedToken.x, state.mintBlockWidth, state.mintBlockHeight).send({
                from: account,
                value: state.mintBlockWidth * state.mintBlockHeight * price * (10 ** 18)
            })
                .on('receipt', function (receipt) {
                    setMessage('')
                    if (!receipt.status) {
                        setProcessing(false);
                        toast.error(receipt.message || "Error while minting!");
                        return;
                    } else {
                        ///  process with backend
                        toast.success('Successfully tokens minted! Updating tokens info ..');
                        setMessage('Updating  token info ...');
                        tokenMinted({
                            tokenId: (selectedToken.y - 1) * 100 + selectedToken.x,
                            width: state.mintBlockWidth,
                            height: state.mintBlockHeight,
                            account: account
                        }, (success, data) => {
                            setMessage('');
                            setProcessing(false);
                            if (success) toast.success('Successfully tokens info updated!');
                            else toast.warning(data.message);

                            setSelectedToken({x: 0, y: 0});
                            setState({
                                mintBlockHeight: 1,
                                mintBlockWidth: 1,
                                description: '',
                                tokenUrl: '',
                                tokenImageUrl: ''
                            });
                        })
                    }

                })
                .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                    setMessage('')
                    setProcessing(false);
                    toast.error(error.message)
                });
        }
    }

    const mintToken = async () => {
        setProcessing(true);
        setMessage('Checking mint condition ...');
        mintAvailable({
            tokenId: tokenInfo.tokenId,
            width: state.mintBlockWidth,
            height: state.mintBlockHeight,
            startX: tokenInfo.startX,
            startY: tokenInfo.startY
        }, (success, res) => {
            setMessage('');
            if (success) {
                if (res.available)
                    mintProcess();
                else {
                    toast.warning(`You can mint with maximum ${res.width} block width and maximum ${res.height} block height!`);
                    setProcessing(false);
                }
            } else {
                toast.warning('backend error!');
                setProcessing(false);
            }
        })
    }

    const updateTokenInfo = () => {

        let tokenId = tokenInfo.groupId ? tokenInfo.group.start : tokenInfo.tokenId;
        let width = tokenInfo.groupId ? tokenInfo.group.width : 1;
        let height = tokenInfo.groupId ? tokenInfo.group.height : 1;
        let info = {...state, tokenId, width, height, groupId: tokenInfo.groupId, imageUrl: tokenInfo.imageUrl};
        setProcessing(true);
        setMessage('uploading metadata ...');
        uploadTokenMetadata(info, (success, data) => {
            setMessage('');
            if (success) {
                if (!tokenInfo.groupId) {
                    setMessage('Setting metadata uri ...');
                    contract.methods.setTokenContentURI(tokenInfo.tokenId, `ipfs://${data.IpfsHash}/${tokenInfo.tokenId}.json`).send({from: account})
                        .on('receipt', function (receipt) {
                            setMessage('');
                            if (!receipt.status) {
                                setProcessing(false);
                                toast.error(receipt.message || "Error while minting!");
                                return;
                            } else {
                                ///  process with backend
                                let updatedTokenInfo = {
                                    ...tokenInfo,
                                    description: state.description,
                                    url: state.tokenUrl,
                                    contentHash: data.IpfsHash,
                                    imageChange: data.imageChange
                                };
                                setMessage('Finalizing token info update ...');
                                updateTokenMetadata(updatedTokenInfo, function (succ, res) {
                                    setProcessing(false);
                                    setMessage('');
                                    if (succ) {
                                        toast.success('Successfully token metadata updated!');
                                        setState({
                                            mintBlockHeight: 1,
                                            mintBlockWidth: 1,
                                            description: '',
                                            tokenUrl: '',
                                            tokenImageUrl: ''
                                        });
                                        setSelectedToken({x: 0, y: 0});
                                    } else {
                                        toast.error(res.msg || 'Error while updating metadata on backend!');
                                    }
                                })
                            }

                        })
                        .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                            setProcessing(false);
                            setMessage('');
                            toast.error(error.message)
                        });
                } else {
                    let tokenInfoURIs = [];
                    for (let i = 0; i < tokenInfo.group.height; i++) {
                        for (let j = 0; j < tokenInfo.group.width; j++) {
                            tokenInfoURIs.push(`ipfs://${data.IpfsHash}/${tokenInfo.group.start + i * 100 + j}.json`);
                        }
                    }
                    console.log(tokenInfoURIs, "tokenInfoURIs", tokenInfo.group.start, tokenInfo.group.width, tokenInfo.group.height);
                    setMessage('Setting metadata uris ...');
                    contract.methods.setTokenGroupContentURIs(tokenInfo.group.start, tokenInfo.group.width, tokenInfo.group.height, tokenInfoURIs).send({from: account})
                        .on('receipt', function (receipt) {
                            if (!receipt.status) {
                                setProcessing(false);
                                toast.error(receipt.message || "Error while minting!");
                                return;
                            } else {
                                ///  process with backend
                                let updatedTokenInfo = {
                                    ...tokenInfo,
                                    description: state.description,
                                    url: state.tokenUrl,
                                    contentHash: data.IpfsHash,
                                    imageChange: data.imageChange
                                };
                                setMessage('Finalizing tokens info update ...');
                                updateTokenMetadata(updatedTokenInfo, function (succ, res) {
                                    setProcessing(false);
                                    setMessage('');
                                    if (succ) {
                                        toast.success('Successfully tokens metadata updated!');
                                        setState({
                                            mintBlockHeight: 1,
                                            mintBlockWidth: 1,
                                            description: '',
                                            tokenUrl: '',
                                            tokenImageUrl: ''
                                        });
                                        setSelectedToken({x: 0, y: 0});
                                    } else {
                                        toast.error(res.msg || 'Error while updating metadata on backend!');
                                    }
                                })

                            }

                        })
                        .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                            setProcessing(false);
                            setMessage('');
                            toast.error(error.message)
                        });
                }
            } else {
                setProcessing(false);
                setMessage('');
                toast.error('Error while uploading metadata into ipfs!');
            }
        })
    }

    const editFile = () => {
        // this.append() `<input type="file" accept="" style="display:'none'"/>`
        if (document.querySelector('.edit_icon input')) {
            document.querySelector('.edit_icon input').click();
            return;
        }
        var inputFile = document.createElement('input');
        inputFile.type = "file";
        inputFile.accept = "image/png, image/gif, image/jpeg";
        inputFile.style.display = 'none';
        inputFile.addEventListener('change', (event) => {

            const file = event.target.files[0];
            const reader = new FileReader();
            reader.addEventListener('load', (e) => {
                const data = e.target.result;
                setState({...state, tokenImageUrl: data})
                inputFile.remove();
            });
            reader.readAsDataURL(file);
            //
        });
        document.querySelector('.edit_icon').append(inputFile);
        inputFile.click();
    }

    const showOwnerInfo = () => {
        console.log("show owner info")
        setSelectedOwner(tokenInfo.ownerId);
        history.push(`/owner/${tokenInfo.ownerId}`)
    }
    const closeOwnerInfoDialog = () => {
        setSelectedOwner(null);
        history.push(`/`)
    }
    const goToToken = (tokenId) =>{
        setSelectedOwner(null);
        history.push(`/tokens/${tokenId}`)
    }
    return (
        <div
            style={{
                justifyContent: "center",
                display: "flex",
                position: "relative",
                backgroundColor: "#140E3A",
                paddingTop: 150,
            }}
        >
            <div
                style={{
                    position: "absolute",
                    width: "100%",
                    bottom: 0,
                    zIndex: 1,
                    height: "20%",
                    backgroundColor: "#050023",
                }}
            >
                <div
                    style={{
                        height: 100,
                        width: 10,
                        bottom: 0,
                        right: sliderPos,
                        position: "absolute",
                    }}
                >
                    <Slider
                        aria-label="ZoomScale"
                        orientation="vertical"
                        min={minscale * 100}
                        step={5}
                        value={(mapStatus.scale * 100).toFixed(0) * 1}
                        onChange={onSliderChange}
                        valueLabelDisplay={"off"}
                        marks={marks}
                        style={{
                            display: account && chainId == (process.env.REACT_APP_MODE == 'TEST' ? 3 : 1) ? 'block' : 'none'
                        }}
                    />
                </div>
            </div>
            <div
                className="mapContainer"
                style={{
                    width: imgWidth,
                    height: imgWidth * 0.8,
                    overflow: "hidden",
                    zIndex: 1,
                    display: account && chainId == (process.env.REACT_APP_MODE == 'TEST' ? 3 : 1) ? 'none' : 'flex',
                    background: `url(${backendUrl}/images/total.png?t=${time})`,
                    //background: `url(http://localhost:5000/images/bg.png)`,
                    backgroundRepeat: "no-repeat",
                    //backgroundSize: "cover",
                    backgroundColor: '#050023ad',
                    backgroundBlendMode: 'soft-light',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#e71919',
                    fontSize: '5rem',
                    textAlign: 'center',
                    fontFamily: 'popins'
                }}
                //  onWheel={containerWheel}
            >
                Please Connect To Wallet or Correct Network!
            </div>
            <div
                ref={imgContainer}
                className="mapContainer"
                style={{
                    width: imgWidth,
                    height: imgWidth,
                    overflow: "hidden",
                    zIndex: 1,
                    display: account && chainId == (process.env.REACT_APP_MODE == 'TEST' ? 3 : 1) ? 'block' : 'none'
                }}
                //  onWheel={containerWheel}
            >
                <div
                    style={{
                        width: 5000,
                        height: 5000,
                        transformOrigin: "left top",
                        overflow: "hidden",
                        backgroundImage: `url(${backendUrl}/images/total.png?t=${time})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                    }}
                    ref={map}
                    className="imgSource"
                >
                    <canvas width="5000" height="5000" ref={canvas}></canvas>
                    {tokenInfo && selectedToken.x > 0 && selectedToken.y > 0 && (
                        <svg
                            width="5000px"
                            height="5000px"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                pointerEvents: "none",
                            }}
                        >
                            <defs>
                                <mask id="hole">
                                    <rect width="100%" height="100%" fill="white"></rect>
                                    <rect
                                        x={50 * tokenInfo.startX}
                                        y={50 * tokenInfo.startY}
                                        width={tokenInfo.groupId ? 50 * tokenInfo.group.width : 50}
                                        height={tokenInfo.groupId ? 50 * tokenInfo.group.height : 50}
                                        fill="black"
                                    ></rect>
                                </mask>
                            </defs>
                            <rect
                                width="100%"
                                height="100%"
                                fill="rgba(0, 0, 0, 0.5)"
                                mask="url(#hole)"
                            ></rect>
                            <rect
                                x={50 * tokenInfo.startX - 10}
                                y={50 * tokenInfo.startY - 10}
                                width={tokenInfo.groupId ? 50 * tokenInfo.group.width + 20 : 70}
                                height={tokenInfo.groupId ? 50 * tokenInfo.group.height + 20 : 70}
                                fill="#4CC9F0"
                                mask="url(#hole)"
                            ></rect>
                        </svg>
                    )}
                </div>

            </div>
            {account && chainId == (process.env.REACT_APP_MODE == 'TEST' ? 3 : 1) && tokenInfo && selectedToken.x > 0 && selectedToken.y > 0 && (
                <Card
                    sx={{
                        minWidth: 275,
                        maxWidth: 360,
                        display: "flex",
                        position: "absolute",
                        zIndex: 2,
                        backgroundColor: "rgba(5,0,35,1)",
                        border: "2px solid white",
                        borderRadius: 5,
                        right: Math.min(Math.max(
                            365,
                            imgWidth +
                            mapContainerMargin -
                            (50 * selectedToken.x * mapStatus.scale + mapStatus.offsetX)
                        ), windowWidth - 365),
                        top:
                            160 + 50 * selectedToken.y * mapStatus.scale + mapStatus.offsetY,
                    }}
                    className="mint_dialog"
                >
                    {tokenInfo.ownerId == '0x0000000000000000000000000000000000000000' && (<CardContent
                        sx={{
                            flex: 1,
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <Box sx={{display: "flex", width: "100%", marginTop: "10px"}}>
                            <Typography
                                sx={{
                                    fontSize: 20,
                                    flex: 1,
                                    marginLeft: "15px",
                                    textAlign: "center",
                                }}
                                color="text.secondary"
                            >
                                Mint Token {(selectedToken.y - 1) * 100 + selectedToken.x}
                            </Typography>
                            <a
                                onClick={() => {
                                    setSelectedToken({x: 0, y: 0});
                                    setState({
                                        mintBlockHeight: 1,
                                        mintBlockWidth: 1,
                                        description: '',
                                        tokenUrl: '',
                                        tokenImageUrl: ''
                                    });
                                }}
                                style={{cursor: "pointer"}}
                                className="close_btn"
                            >
                                &times;
                            </a>
                        </Box>
                        <a style={{color: "white", textDecoration: "underline"}}>
                            Go to token
                        </a>
                        <Typography
                            component="div"
                            sx={{
                                textAlign: "center",
                                marginTop: "20px",
                                marginBottom: "20px",
                            }}
                        >
                            You found a un-minted token <br/>
                            Nice! You are about to become <br/>
                            part of crypto history
                        </Typography>
                        <Box sx={{marginBottom: "10px", display: "flex"}}>
                            <Box
                                xs={6}
                                sx={{
                                    textAlign: "right",
                                    fontWeight: "600",
                                    paddingRight: "10px",
                                }}
                            >
                                Block Width
                            </Box>
                            <Box xs={6} sx={{display: "flex", alignItems: "center"}}>
                                <input
                                    type="number"
                                    className="blockNumber"
                                    name="mintBlockWidth"
                                    value={state.mintBlockWidth}
                                    style={{
                                        textAlign: "center",
                                        width: "60px",
                                        paddingLeft: "10px",
                                        height: "30px",
                                    }}
                                    onChange={changeHandler}
                                />
                            </Box>
                        </Box>
                        <Box sx={{display: "flex"}}>
                            <Box
                                xs={6}
                                sx={{
                                    textAlign: "right",
                                    fontWeight: "600",
                                    paddingRight: "5px",
                                }}
                            >
                                Block Height
                            </Box>
                            <Box xs={6} sx={{display: "flex", alignItems: "center"}}>
                                <input
                                    type="number"
                                    className="blockNumber"
                                    name="mintBlockHeight"
                                    value={state.mintBlockHeight}
                                    style={{
                                        textAlign: "center",
                                        width: "60px",
                                        paddingLeft: "10px",
                                        height: "30px",
                                    }}
                                    onChange={changeHandler}
                                />
                            </Box>
                        </Box>
                        <Typography
                            component="div"
                            sx={{
                                textAlign: "center",
                                marginTop: "20px",
                                marginBottom: "10px",
                            }}
                        >
                            Current Token Price: {price} Eth
                            <br/>
                            Connected account balance: {balance.toFixed(3)} Eth
                        </Typography>
                        <Button
                            sx={{textAlign: "center", fontWeight: "bold"}}
                            variant='outlined'
                            disabled={state.mintBlockWidth * state.mintBlockHeight == 0}
                            onClick={mintToken}
                        >
                            Mint {state.mintBlockWidth * state.mintBlockHeight} token for
                            ${state.mintBlockWidth * state.mintBlockHeight * price} Eth
                        </Button>
                    </CardContent>)}
                    {tokenInfo.ownerId == account && (<CardContent
                        sx={{
                            flex: 1,
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <Box sx={{display: "flex", width: "100%", marginTop: "10px"}}>
                            <Typography
                                sx={{
                                    fontSize: 20,
                                    flex: 1,
                                    marginLeft: "15px",
                                    textAlign: "center",
                                }}
                                color="text.secondary"
                            >
                                Mint Token {(selectedToken.y - 1) * 100 + selectedToken.x}
                            </Typography>
                            <a
                                onClick={() => {
                                    setSelectedToken({x: 0, y: 0});
                                    setState({
                                        mintBlockHeight: 1,
                                        mintBlockWidth: 1,
                                        description: '',
                                        tokenUrl: '',
                                        tokenImageUrl: ''
                                    });
                                }}
                                style={{cursor: "pointer"}}
                                className="close_btn"
                            >
                                &times;
                            </a>
                        </Box>
                        <a style={{color: "white", textDecoration: "underline"}}>
                            Go to token
                        </a>
                        <Typography
                            component="div"
                            sx={{
                                textAlign: "center",
                                marginTop: "20px",
                                marginBottom: "20px",
                            }}
                        >
                            <Input sx={{width: '300px'}} name='tokenUrl' onChange={changeHandler} value={state.tokenUrl}
                                   placeholder={'No have site link'}/>
                        </Typography>
                        <Box className="token_image_container">
                            <img className="token_image"
                                 ref={tokenImage}
                                 src={state.tokenImageUrl}
                                 style={{aspectRatio: tokenImageAspectRatio}}
                            />
                            <a className="edit_icon" onClick={editFile}>
                                <Edit></Edit>
                            </a>

                        </Box>
                        <textarea
                            style={{
                                borderRadius: "3px",
                                width: "300px",
                                backgroundColor: 'transparent'
                            }}
                            className='token_description'
                            name='description'
                            onChange={changeHandler}
                            value={state.description}
                        />
                        <Button
                            sx={{textAlign: "center", fontWeight: "bold"}}
                            variant='outlined'
                            onClick={updateTokenInfo}
                        >
                            Update Token Info
                        </Button>
                    </CardContent>)}
                    {tokenInfo.ownerId != '0x0000000000000000000000000000000000000000' && tokenInfo.ownerId != account && (
                        <CardContent
                            sx={{
                                flex: 1,
                                alignItems: "center",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}
                        >
                            <Box sx={{display: "flex", width: "100%", marginTop: "10px"}}>
                                <Typography
                                    sx={{
                                        fontSize: 20,
                                        flex: 1,
                                        marginLeft: "15px",
                                        textAlign: "center",
                                        textTransform: "uppercase"
                                    }}
                                    color="text.secondary"
                                >
                                    TOKEN #{tokenInfo.tokenId}
                                </Typography>
                                <a
                                    onClick={() => {
                                        setSelectedToken({x: 0, y: 0});
                                        setState({
                                            mintBlockHeight: 1,
                                            mintBlockWidth: 1,
                                            description: '',
                                            tokenUrl: '',
                                            tokenImageUrl: ''
                                        });
                                    }}
                                    style={{cursor: "pointer"}}
                                    className="close_btn"
                                >
                                    &times;
                                </a>
                            </Box>
                            <a style={{color: "white", textDecoration: "underline"}} href={tokenInfo.url}>
                                {tokenInfo.url ? (tokenInfo.url.indexOf('http') === 0 ? new URL(tokenInfo.url).host : tokenInfo.url) : 'No have link'}
                            </a>
                            <Typography
                                component="div"
                                sx={{
                                    textAlign: "center",
                                    marginTop: "15px",
                                    marginBottom: "5px",
                                }}
                            >
                                Owned By
                            </Typography>
                            <a
                                style={{
                                    textAlign: "center",
                                    textDecoration: "underline",
                                    marginBottom: "10px",
                                    cursor: "pointer"
                                }}
                                onClick={showOwnerInfo}
                            >
                                {shortenAddress(tokenInfo.ownerId)}
                            </a>
                            <Box className="token_image_container">
                                <img className="token_image"
                                     ref={tokenImage}
                                     src={state.tokenImageUrl}
                                     style={{aspectRatio: tokenImageAspectRatio}}
                                />
                            </Box>
                            <textarea
                                style={{
                                    borderRadius: "3px",
                                    width: "300px",
                                    backgroundColor: 'transparent'
                                }}
                                className='token_description'
                                name='description'
                                onChange={() => {
                                }}
                                value={state.description}
                            />
                            <Box sx={{display: "flex", width: "100%", marginTop: "10px"}}>
                                <Button
                                    sx={{textAlign: "center", fontWeight: "bold", marginRight: '10px'}}
                                    variant='outlined'

                                >
                                    Bid On Token
                                </Button>
                                <Button
                                    sx={{textAlign: "center", fontWeight: "bold"}}
                                    variant='outlined'

                                >
                                    View on Etherscan
                                </Button>
                            </Box>
                        </CardContent>)}
                </Card>
            )}
            {message && (<Snackbar open={true} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                                   onClose={() => setMessage('')}
            >
                <Alert onClose={() => setMessage('')} severity="info" sx={{width: '100%', background: '#42359896'}}>
                    {message}
                </Alert>
            </Snackbar>)}
            {account && chainId == (process.env.REACT_APP_MODE == 'TEST' ? 3 : 1) && selectedOwner &&
            <DraggableDialog title={`${selectedOwner==account?'My':shortenAddress(selectedOwner)+'\'s'}  Pixels`}
                             onClose={closeOwnerInfoDialog}
            >
                <DialogContent className="owner_tokens">
                    <Grid container>
                        {
                            selectedTokens.map((token,key)=>{
                                return (<Grid item xs={12} sx={{display:'flex'}} key={key} className="owner_token"
                                              onClick={()=>{goToToken(token.tokens[0])}}
                                >
                                    <Box className="owner_token_image">
                                        <img
                                             src={token.groupId?`${backendUrl}/images/groupImage/${token.groupId}.png`:`${backendUrl}/images/resizeImage/${token.tokenId}.png`}
                                        />
                                    </Box>
                                    <Box className="owner_token_info">
                                        <a>{
                                            token.tokens.map((item) =>'#'+item).join(',')
                                        }</a>
                                        <p>{token.description}</p>
                                    </Box>
                                </Grid>)
                            })
                        }
                        {
                            !selectedTokens.length && (<Alert severity="warning">No Have Pixels!</Alert>)
                        }
                    </Grid>
                </DialogContent>
            </DraggableDialog>}
            {processing && (<Box sx={{
                position: 'fixed',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 100,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#0009'
            }}>
                <CircularProgress color="warning"/>
            </Box>)}
        </div>
    );
}
export default TokenSection;
